import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { _ } from "../utils/i18n";

const SectionWrapper = styled.div`
  width: 100%;
  & > * + * {
    margin-block-start: 1rem;
  }

  & > .header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;
    gap: 0.75rem;
  }

  & > .header > .count {
    font-size: 0.75rem;
    font-weight: bold;
    opacity: 0.6;
  }

  & > .header > * {
    margin: 0;
    width: unset;
  }

  & > .content {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(max(200px, (100% / var(--max-columns)) - 1em), 1fr)
    );
    gap: 1em;
  }

  & > .content > * {
    width: 100%;
  }

  & > .button-wrapper {
    display: flex;
    justify-content: center;
    margin-block: 3rem;
  }
`;

const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  min-height: 3rem;

  & > .label {
    text-decoration: underline;
  }
`;

const Section = ({
  title,
  description,
  loadButtonLabel,
  maxColumns = 4,
  maxRows = 2,
  children,
}) => {
  const chunkSize = maxColumns * maxRows;
  const [numVisible, setNumVisible] = React.useState(chunkSize);
  const [numChildren] = React.useState(() => {
    return React.Children.count(children);
  });
  return (
    <SectionWrapper>
      <div className="header">
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        <div className="count">({numChildren})</div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: description }} />
      <div className="content" style={{ "--max-columns": maxColumns }}>
        {React.Children.toArray(children)
          .slice(0, numVisible)
          .map((child) => child)}
      </div>
      {numChildren > numVisible && (
        <div className="button-wrapper">
          <Button onClick={() => setNumVisible(numVisible + chunkSize)}>
            <span
              className="label"
              dangerouslySetInnerHTML={{
                __html: loadButtonLabel || _("Last inn flere"),
              }}
            />
            &ensp;+
          </Button>
        </div>
      )}
    </SectionWrapper>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  loadButtonLabel: PropTypes.string,
  maxColumns: PropTypes.number,
  maxRows: PropTypes.number,
  children: PropTypes.node,
};

export default Section;
